// components/Login.js
import React, { useState, useContext } from 'react';
import { supabase } from '../supabaseClient';
import logo from '../logo2.png';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';  // Import AuthContext

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);  // Use login function from AuthContext
    const navigate = useNavigate();  // Use navigate for redirection

    const handleLogin = async (e) => {
        e.preventDefault();

        // Fetch user data including the role
        const { data: userData, error: fetchError } = await supabase
            .from('users')
            .select('password, role')  // Select password and role
            .eq('email', email)
            .single();

        if (fetchError || !userData) {
            setError('User not found');
            return;
        }

        const storedPassword = userData.password;
        const userRole = userData.role; // Get the user's role

        if (password === storedPassword) {
            login(userRole);  // Update the authentication state with the user's role
            navigate('/file-page');  // Redirect to the dashboard
        } else {
            setError('Password Incorrect, If Your Forgot your password please contact Mr.Hu');
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="w-full max-w-md p-8 space-y-6 bg-white shadow-lg rounded-lg">
                <div className="text-center">
                    <img src={logo} alt="Kindbridge Investments" className="w-64 mx-auto mb-4" />
                    <h2 className="text-xl text-gray-600">File Management System</h2>
                </div>
                {error && <p className="text-red-500 text-center mt-4">{error}</p>}
                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                        <input
                            type="email"
                            id="email"
                            placeholder="please enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full mt-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                        <input
                            type="password"
                            id="password"
                            placeholder="please enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full mt-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <button type="submit" className="w-full py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition duration-300">Login</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
